export function getIdFromURL(url: string): string | undefined {
  const result = url.match(/[0-9]{8,12}/);
  if (!result) return undefined;
  return result[0];
}
